import { NavLink, useNavigate } from 'react-router-dom';
import { useLocalization } from '../../contexts/LocalizationContext';
import { useAuth } from '../../contexts/AuthContext';

const NavMenu = ({ onLinkClick }) => {
  const { isRtl } = useLocalization();
  const { logout } = useAuth();
  const navigate = useNavigate();
  const handleLink = () => { if (onLinkClick) onLinkClick(); };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="sidebar-nav">
      <div className="sidebar-header">
        <div className="sidebar-brand">
          <img
            src="/logo.svg"
            alt={isRtl ? 'رمال الخليج' : 'Rimal Al Khalij'}
            className="sidebar-logo"
          />
        </div>
      </div>

      <div className="sidebar-content">

        {/* Main Menu */}
        <div className="nav-section">
          <span className="nav-section-title">{isRtl ? 'القائمة الرئيسية' : 'MAIN MENU'}</span>

          <NavLink to="/home" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} onClick={handleLink}>
            <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="3" width="7" height="7" rx="1"></rect>
              <rect x="14" y="3" width="7" height="7" rx="1"></rect>
              <rect x="3" y="14" width="7" height="7" rx="1"></rect>
              <rect x="14" y="14" width="7" height="7" rx="1"></rect>
            </svg>
            <span>{isRtl ? 'الرئيسية' : 'Dashboard'}</span>
          </NavLink>

          <NavLink to="/orders" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} onClick={handleLink}>
            <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <path d="M16 10a4 4 0 0 1-8 0"></path>
            </svg>
            <span>{isRtl ? 'الطلبات' : 'Orders'}</span>
          </NavLink>

          <NavLink to="/customers" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} onClick={handleLink}>
            <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
            <span>{isRtl ? 'العملاء' : 'Customers'}</span>
          </NavLink>
        </div>

        {/* Catalog */}
        <div className="nav-section">
          <span className="nav-section-title">{isRtl ? 'الكتالوج' : 'CATALOG'}</span>

          <NavLink to="/products" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} onClick={handleLink}>
            <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
            </svg>
            <span>{isRtl ? 'المنتجات' : 'Products'}</span>
          </NavLink>

          <NavLink to="/product-types" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} onClick={handleLink}>
            <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
              <polyline points="2 17 12 22 22 17"></polyline>
              <polyline points="2 12 12 17 22 12"></polyline>
            </svg>
            <span>{isRtl ? 'أنواع المنتجات' : 'Product Types'}</span>
          </NavLink>

          <NavLink to="/brands" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} onClick={handleLink}>
            <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
              <line x1="7" y1="7" x2="7.01" y2="7"></line>
            </svg>
            <span>{isRtl ? 'العلامات التجارية' : 'Brands'}</span>
          </NavLink>

          <NavLink to="/categories" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} onClick={handleLink}>
            <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
            </svg>
            <span>{isRtl ? 'التصنيفات' : 'Categories'}</span>
          </NavLink>

          <NavLink to="/fragrance-notes" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} onClick={handleLink}>
            <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
            </svg>
            <span>{isRtl ? 'نوتات العطر' : 'Fragrance Notes'}</span>
          </NavLink>
        </div>

        {/* Marketing */}
        <div className="nav-section">
          <span className="nav-section-title">{isRtl ? 'التسويق' : 'MARKETING'}</span>

          <NavLink to="/home-sections" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} onClick={handleLink}>
            <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="4" width="18" height="6" rx="1"></rect>
              <rect x="3" y="14" width="8" height="6" rx="1"></rect>
              <rect x="13" y="14" width="8" height="6" rx="1"></rect>
            </svg>
            <span>{isRtl ? 'أقسام الصفحة الرئيسية' : 'Home Sections'}</span>
          </NavLink>

          <NavLink to="/advertisements" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} onClick={handleLink}>
            <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
              <line x1="8" y1="21" x2="16" y2="21"></line>
              <line x1="12" y1="17" x2="12" y2="21"></line>
            </svg>
            <span>{isRtl ? 'الإعلانات' : 'Advertisements'}</span>
          </NavLink>

          <NavLink to="/discounts" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} onClick={handleLink}>
            <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
            </svg>
            <span>{isRtl ? 'الخصومات والعروض' : 'Discounts & Promotions'}</span>
          </NavLink>

          <NavLink to="/notifications" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} onClick={handleLink}>
            <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
            <span>{isRtl ? 'الإشعارات' : 'Notifications'}</span>
          </NavLink>
        </div>

        {/* Admin */}
        <div className="nav-section">
          <span className="nav-section-title">{isRtl ? 'الإدارة' : 'ADMIN'}</span>

          <NavLink to="/admin/users" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} onClick={handleLink}>
            <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
            <span>{isRtl ? 'المستخدمون' : 'Users'}</span>
          </NavLink>

          <NavLink to="/arqam" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} onClick={handleLink}>
            <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
            <span>{isRtl ? 'حساب الرسائل' : 'SMS Account'}</span>
          </NavLink>

          <NavLink to="/shipping-zones" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} onClick={handleLink}>
            <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="1" y="3" width="15" height="13"></rect>
              <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon>
              <circle cx="5.5" cy="18.5" r="2.5"></circle>
              <circle cx="18.5" cy="18.5" r="2.5"></circle>
            </svg>
            <span>{isRtl ? 'أجور التوصيل' : 'Shipping Zones'}</span>
          </NavLink>
        </div>

      </div>

      <div className="sidebar-footer">
        <button className="logout-link" onClick={handleLogout}>
          <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
            <polyline points="16 17 21 12 16 7"></polyline>
            <line x1="21" y1="12" x2="9" y2="12"></line>
          </svg>
          <span>{isRtl ? 'تسجيل الخروج' : 'Logout'}</span>
        </button>
      </div>
    </nav>
  );
};

export default NavMenu;
